// // import React, { useState, useEffect } from 'react';
// // import classNames from 'classnames';

// // import css from './SizeButtons.module.css';

// // const SizeButtons = props => {
// //   const { userTypeConfig, changeForm, formValues, name } = props;

// //   const typeButtons = userTypeConfig.map(item => {
// //     const classes =
// //       formValues[name] === item.key
// //         ? classNames(css.typeButtonActive, css.typeButton)
// //         : css.typeButton;
// //     return (
// //       <div className={classes} key={item.key} onClick={() => changeForm(item.key)}>
// //         {item.label}
// //       </div>
// //     );
// //   });
// //   return userTypeConfig ? <div className={css.userTypeButtons}>{typeButtons}</div> : null;
// // };

// // export default SizeButtons;
// import React from 'react';
// import { Field } from 'react-final-form';
// import classNames from 'classnames';
// import css from './SizeButtons.module.css';

// const SizeButtons = ({ userTypeConfig = [], name }) => {
//   if (userTypeConfig.length === 0) return null;

//   return (
//     <Field name={name}>
//       {({ input }) => {
//         const typeButtons = userTypeConfig.map(item => {
//           const isSelected = input.value === item.key;
//           const classes = isSelected
//             ? classNames(css.typeButtonActive, css.typeButton)
//             : css.typeButton;

//           return (
//             <div className={classes} key={item.key} onClick={() => input.onChange(item.key)}>
//               {item.label}
//             </div>
//           );
//         });

//         return <div className={css.userTypeButtons}>{typeButtons}</div>;
//       }}
//     </Field>
//   );
// };

// export default SizeButtons;
import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import css from './SizeButtons.module.css';

const SizeButtons = ({ userTypeConfig = [], name }) => {
  if (userTypeConfig.length === 0) return null;

  return (
    <Field name={name}>
      {({ input }) => {
        const handleToggle = key => {
          const currentValue = input.value || [];
          const newValue = currentValue.includes(key)
            ? currentValue.filter(item => item !== key) // Remove if already selected
            : [...currentValue, key]; // Add if not selected

          input.onChange(newValue);
        };

        const typeButtons = userTypeConfig.map(item => {
          const isSelected = (input.value || []).includes(item.key);
          const classes = isSelected
            ? classNames(css.typeButtonActive, css.typeButton)
            : css.typeButton;

          return (
            <div className={classes} key={item.key} onClick={() => handleToggle(item.key)}>
              {item.label}
            </div>
          );
        });

        return <div className={css.userTypeButtons}>{typeButtons}</div>;
      }}
    </Field>
  );
};

export default SizeButtons;
